import React, { useRef } from 'react';

import SummaryScheduleCalendarElement from './SummaryScheduleCalendarElement';

export default function SummaryScheduleCalendarIndex(props) {
    const calendarRef = useRef(null);

    const changedateDatepickerDate = (name, e) => {
        const calendarApi = calendarRef.current.getApi();
        props.setDate(e);

        const calendarDateObj = calendarApi.getDate();

        const year = calendarDateObj.getFullYear();
        const month = String(calendarDateObj.getMonth() + 1).padStart(2, '0');
        const day = String(calendarDateObj.getDate()).padStart(2, '0');

        const calendarDate = `${year}-${month}-${day}`;

        if (e !== calendarDate) {
            calendarApi.gotoDate(e);
        }
    };

    const calendarDateChanged = (arg) => {
        const calendarDateStr = arg.startStr.split('T')[0];
        if (calendarDateStr !== props.date) {
            props.setDate(calendarDateStr);
        }
    };

    return (
        <div>
            <div className="detailed_schedule_calendar">
                <SummaryScheduleCalendarElement
                    events={props.schedules}
                    resources={props.venues}
                    initialDate={props.date}
                    calendarRef={calendarRef}
                    date={props.date}
                    dateChangedHandler={calendarDateChanged}
                    minDate={props.minDate}
                    maxDate={props.maxDate}
                    changedateDatepickerDate={changedateDatepickerDate}
                />
            </div>
        </div>
    );
}
